import React, {CSSProperties, FunctionComponent, useEffect, useState} from "react";
import OurModal from "../OurModal/OurModal";
import {OurModalProps} from "../OurModal/OurModalTypes";
import {X} from "lucide-react";
import "../../styles/Modal.scss";
import "./OurPaperModal.scss";
import IconButton from "@mui/material/IconButton";
import {CloseTooltip} from "../../styles/MaterialUIStyling";
import OurToastContainer from "../OurToastContainer/OurToastContainer";
import {isHumanSite} from "../../utils/siteUtils";

export type PaperModalProps = OurModalProps & {
  overrideModalStyle?: CSSProperties,
  overrideCloseIconStyle?: CSSProperties,
  overrideLeftSideElementStyle?: CSSProperties,
  overrideNavBarStyle?: CSSProperties,
  disableClose?: boolean,
  leftSideElement?: JSX.Element,
  toastContainerId?: string,
  scrollable?: boolean,
}

const OurPaperModal: FunctionComponent<PaperModalProps> = (props) => {
  const {
    ariaLabel,
    ariaLabelledBy,
    children,
    disableClose,
    leftSideElement,
    overrideCloseIconStyle,
    overrideModalStyle,
    overrideLeftSideElementStyle,
    overrideNavBarStyle,
    parentToggle,
    toastContainerId,
    setParentClose,
    scrollable,
  } = props;

  const isHumanSiteValue = useState<boolean>(isHumanSite())[0]

  useEffect(() => {
  }, []);

  useEffect(() => {

  }, [leftSideElement])

  return (<OurModal disableClose={disableClose}
                    parentToggle={parentToggle}
                    setParentClose={setParentClose}
                    ariaLabel={ariaLabel}
                    ariaLabelledBy={ariaLabelledBy}
    >
      <div className="modal-container paper-base"
           data-is-human={isHumanSiteValue}
           style={overrideModalStyle}>
        {disableClose && leftSideElement === undefined ? undefined : <>
          <div className="flex-row paper-modal-nav-bar"
               data-is-human={isHumanSiteValue}
               style={overrideNavBarStyle}>
            <div className="paper-modal-nav-backdrop"
                 data-is-human={isHumanSiteValue}/>
            <div className="left-text paper-modal-left-side-element" style={overrideLeftSideElementStyle}>
              {leftSideElement}
            </div>
            {disableClose ? undefined :
             <div className="paper-modal-close-icon" style={overrideCloseIconStyle}>
               <CloseTooltip title={"Close"} arrow={false} placement={"top"}>
                 <IconButton size="small"
                             onClick={setParentClose}>
                   <X/>
                 </IconButton>
               </CloseTooltip>
             </div>}
          </div>
        </>
        }
        <div className="modal-base" style={scrollable ? {height: "100%", overflowY: "auto"} : {}}>
          {children}
        </div>
      </div>
      {toastContainerId ? <OurToastContainer containerId={toastContainerId}/> : undefined}
    </OurModal>
  )

}

export default OurPaperModal;
